import React, { useState } from 'react';
import { buildEventIcs, icsFileName } from '../../utils/ics';

/**
 * "In meinen Kalender" - laedt den Termin als .ics-Datei herunter.
 *
 * Bewusst eine Datei und kein Google-Kalender-Link: Die .ics versteht jeder
 * Kalender (Apple, Outlook, Thunderbird, und auf Android landet sie in Google
 * Kalender), sie verraet keinem fremden Dienst, welchen Termin jemand
 * anschaut, und sie funktioniert auch ohne Konto bei irgendwem.
 *
 * Steht bewusst auch auf den oeffentlichen Terminkarten: Wer die Seite ohne
 * Login besucht, soll sich einen Termin merken koennen.
 */
export default function AddToCalendarButton({ event, className = '' }) {
  const [failed, setFailed] = useState(false);

  function download() {
    const ics = buildEventIcs(event, { origin: window.location.origin });
    // Ohne gueltigen Beginn gibt es keine gueltige Datei - dann lieber nichts
    // tun als etwas herunterzuladen, das der Kalender ablehnt.
    if (!ics) {
      setFailed(true);
      return;
    }

    const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = icsFileName(event?.title);
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Erst freigeben, wenn der Browser die Datei geholt hat. Sofortiges
    // revokeObjectURL bricht den Download in manchen Browsern ab - dieselbe
    // Falle wie beim Zuschnitt-Editor, wo die Objekt-URL freigegeben wurde,
    // waehrend das Bild noch lud.
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }

  if (failed) {
    return <span className="mt-muted">Zu diesem Termin fehlt eine Zeitangabe.</span>;
  }

  return (
    <button
      type="button"
      className={className || 'mt-btn mt-btn--ghost mt-btn--sm'}
      onClick={download}
    >
      <span aria-hidden="true">📅</span> In meinen Kalender
    </button>
  );
}
